import { Form, Input, Radio, Switch } from "antd";
import React from "react";
import ReactQuill, { Quill } from "react-quill-new";
import { webFonts } from "@/utils/fonts";
import { tabProps } from "@/utils/globalPropsTypes";

// Add fonts to whitelist
const Font = Quill.import("formats/font");
Font.whitelist = webFonts;
Quill.register(Font, true);

const Size = Quill.import("formats/size");
Size.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "31px",
  "32px",
];

function BasicTab({ editItem }) {
  const { component } = editItem;
  return (
    <>
      {component === "iframe" ? (
        <>
          <Form.Item label="Iframe Link" name="iframe">
            <Input
              placeholder="Iframe Link"
              className="w-100"
              // onChange={({ target }) => setIframe(target?.value)}
            />
          </Form.Item>
        </>
      ) : (
        <>
          {" "}
          <Form.Item
            label="Title"
            name="chartTitle"
            rules={[{ required: true, message: "Enter Tile Name" }]}
            getValueFromEvent={(content) => content}
          >
            <ReactQuill modules={counterTitleModules} theme="snow" placeholder="Enter Tile Name" maxLength={4} />
          </Form.Item>
          {["bar", "line", "comboBar"].includes(component) && (
            <Form.Item label="Select Chart Type" name="chartType">
              <Radio.Group className="d-flex">
                <Radio.Button className="w-100 text-center" value="canvasJs">
                  CanvasJs
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="chartJs">
                  ChartJs
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          )}
          <Form.Item
            layout="horizontal"
            label="Hide Title"
            name="isTitleHidden"
            colon={false}
            className="right-label mb-0"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            layout="horizontal"
            label="Hide Border"
            name="isBorderHidden"
            colon={false}
            className="right-label mb-0"
          >
            <Switch />
          </Form.Item>
          {(component === "line" || component === "bar") && (
            <Form.Item
              layout="horizontal"
              label="Show Thumbs-up"
              name="showThumbsUp"
              colon={false}
              className="right-label mb-0"
            >
              <Switch />
            </Form.Item>
          )}
        </>
      )}
    </>
  );
}

export default BasicTab;

const counterTitleModules = {
  toolbar: [
    [{ font: Font.whitelist }],
    [{ size: Size.whitelist }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }],
    ["clean"],
  ],
  clipboard: {
    matchVisual: false,
  },
};

BasicTab.propTypes = tabProps;
